import { Expose } from 'class-transformer';
import { NotificationType } from '@shared-features/enums/shared-enums.enum';
import { Model } from '@shared/models/model';

export class NotificationItem extends Model {
  public timeout = 5000;

  @Expose() id: string;
  @Expose() title: string;
  @Expose() body: string;
  @Expose() type: NotificationType = NotificationType.Shipment;
  @Expose() elementId: number;
  /** Chat only: the Firestore conversation the message belongs to. */
  @Expose() conversationId?: string;
  @Expose() isRead = false;
  @Expose() createdAt: number;
  @Expose() updatedAt: number;

}
